import { render, staticRenderFns } from "./TotalContainer.vue?vue&type=template&id=6defa2ef&"
import script from "./TotalContainer.vue?vue&type=script&lang=js&"
export * from "./TotalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports